import React from 'react'
import ReactDOM from 'react-dom'
import i18next from 'i18next'
import {I18nextProvider, initReactI18next} from 'react-i18next'

import './constants/translations'
import FingerprintGetter from './FingerprintGetter'

i18next
  .use(initReactI18next)
  .init({
    interpolation: {escapeValue: false},
  })

ReactDOM.render((
  <I18nextProvider i18n={i18next}>
    <FingerprintGetter/>
  </I18nextProvider>
), document.getElementById('root'))
